import { useContext, useEffect, useState } from "react";
import { userStoreContext } from "../store/userStore";
import { Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

const Login = observer(() => {
  const { t } = useTranslation();
  const store = useContext(userStoreContext);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    setIsAuthenticated(store.isAuthenticated);
  }, [store.client, store.isAuthenticated]);

  if (isAuthenticated) {
    // Redirect to home page if user is authenticated
    //return <Navigate to='/' replace />;
  }
  return (
    <>
      <h1>{t("routes.needLogin")}</h1>
      <h2>{isAuthenticated ? store.userId : "anonymous"}</h2>
    </>
  );
});

export default Login;
